import React from 'react'
import styled from 'styled-components'


const MetamaskButton = styled.button`
  cursor: pointer;
  vertical-align: middle;
  align-items: center;
  background-color: ${({ theme }) => (theme.isDark ? 'rgb(94, 88, 77)' : '#e3e3e3')};
  border: 0px;
  border-radius: 16px;
  box-shadow: none;
  color: rgb(255, 114, 13);
  cursor: pointer;
  display: inline-block;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  width: max-content;
  height: 32px;
  line-height: 1;
  letter-spacing: 0.03em;
  justify-content: center;
  outline: 0px;
  padding: 0px 16px;
  transition: background-color 0.2s ease 0s;
  opacity: 1;
  margin-left: 12px;

  &:hover {
    opacity: 0.8;
  }
`

const AddToMetamask = (props) => {
    return (
        <MetamaskButton {...props}>
            +<MetamaskLogo width={16} height={16} style={{width:"16px",height:"16px", marginLeft:"8px", verticalAlign: "middle"}}/>
        </MetamaskButton>
    )
}

export const MetamaskLogo = (props) => {
  return (
    <img src="/images/metamask.png" alt="metamask logo" {...props} />
  )
}

export default AddToMetamask
